import { render } from "./PhoneNumber.vue?vue&type=template&id=46695a64&ts=true"
import script from "./PhoneNumber.ts?vue&type=script&lang=ts&external"
export * from "./PhoneNumber.ts?vue&type=script&lang=ts&external"

import "./PhoneNumber.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__